module.exports = __webpack_public_path__ + "static/media/trainingConsistencyIcon.c6d8c75f.png";